// tslint:disable: quotemark max-line-length

import countryList from '~common/app/i18n/countries-fr';

export const french = {

  // Auth

  "auth": {
    "login": {
      "heading": "Se connecter à votre compte",
      "heading.sso": "Single Sign-on",
      "forgot-password": "Mot de passe oublié ?",
      "remember-me": "Se souvenir de moi",
      "button.login": "S’identifier",
      "form.error": "Identifiant ou mot de passe incorrect.",
      "signup": "Pas encore de compte ? Inscrivez-vous !",
      "login-sso": "Identification SSO",
      "login-back": "Identification standard",
      "weak-password":
        `Votre mot de passe n'est pas assez fort.
 Veuillez le changer pour sécuriser votre compte.`
    },
    "signup": {
      "heading": "Créer un compte",
      "button.login": "S’inscrire",
      "form.error": "Une erreur est survenue.",
      "form.success": "Un email vient de vous être envoyé.",
      "signin": "Déjà un compte ? S’identifier !",
      "hint": "Les instructions à suivre y seront envoyées.",
    }
  },

  // Onboarding

  "onboarding": {
    "siret": {
      "heading": "Connaissez-vous votre SIRET ?",
      "heading.shop": "Détails du magasin",
      "label": "Mon SIRET est :",
      "button.search": "Rechercher par SIRET",
      "empty": "Aucun magasin n’a été trouvé avec ce SIRET",
      "sidebar": {
        "gifts": "Dons",
        "consumers": "Consommateurs",
        "performances": "Performances",
        "heading": "We’re glad you’re taking this step!",
        "text": "First, we’ll need to get a little information about your point of sales.",
        "help1.heading": "Vous possédez plus d’un point de vente ?",
        "help1.text": "Aucun souci, vous pourrez en ajouter plus tard.",
      }
    },
    "tos": {
      "heading": "Conditions de Service",
      "scrolldown": "Scroller vers le bas pour accepter",
      "accept1": "J’ai lu tout le contrat ci-dessus",
      "accept2": "Je déclare accepter les conditions de ce document"
    }
  },

  // Dashboards

  "dashboard": {
    "main": {
      "tab": {
        "offer": "Offre",
        "cardholder": "Porteur de carte",
        "merchant": "Marchand",
      },
      "heading": "Tableau de bord",
      "heading.reach": "Ciblage",
      "heading.turnover": "Chiffre d’affaires",
      "heading.statistics": "Statistiques",
      "heading.advertising": "Annonces gratuites",
      "empty": "Il n’y a pas encore de données disponibles…",
    },
    "charts": {
      "subscribers-evolution": "Évolution des souscriptions",
      "churners-evolution": "Évolution des désinscriptions",
      "rewarded-consumers": "Consommateurs récompensés",
      "reward-amount-commission": "Montant des récompenses + commission",
      "number-of-rewards": "Nombre de récompenses",
      "voucher-discount": "Montant des récompenses + commission",
      "voucher-by-consumers": "Consommateurs récompensés",
      "vouchers": "Vouchers",
      "gifts-count": "Nombre de cadeaux",
      "gifts-amount": "Montant des cadeaux",
      "activated-gifts": "Cadeaux activés",
      "unique-coupons": "Coupons uniques",
      "unique-activated-coupons": "Coupons uniques activés",
      "generic-coupons": "Coupons génériques",
      "generic-activated-coupons": "Coupons génériques activés",
      "lbs-live-merchants": "LBS Nombre de marchands actifs",
      "lbs-churners-merchants": "LBS Nombre de marchands désinscrits",
      "lbs-cashback-reward-amount": "LBS Cashback - Montant des récompenses par mois",
      "labels": {
        "subscriptions": "Inscriptions",
        "cumulative-subscriptions": "Inscriptions cumulées",
        "churners": "Désinscriptions",
        "cumulative-churners": "Désinscriptions cumulées",
        "rewarded": "Récompensés",
        "program-fees": "Commissions",
        "reward-amount": "Montant récompenses",
        "discount": "Réduction",
        "fees": "Commission",
        "count": "Nombre",
        "amount": "Montant",
        "coupons": "Coupons",
        "activated": "Activés",
      },
    },
    "metrics": {
      "total-subscribers": "Total souscriptions",
      "total-subscribers-hint": "Nombre total d'inscriptions au programme sur la plage de date observée",
      "total-churners": "Total désinscriptions",
      "total-churners-hint": "Nombre total d'utilisateurs qui se sont désabonnés du programme sur la plage de date observée",
      "total-onboarded": "Total inscrits depuis toujours",
      "total-onboarded-hint": "Nombre total d'utilisateurs enregistrés dans le programme à ce jour",
      "total-rewarded": "Total récompensés",
      "total-rewarded-hint": "Nombre total d'utilisateurs ayant généré du cashback sur la plage de date observée du programme",
      "total-playground": "Total playground",
      "total-playground-hint": "Montant total des revenus (cashbacks + commissions) générés sur la plage de date observée du programme",
      "total-commission": "Total commission",
      "total-commission-hint": "Montant total des commissions générées sur la plage de date observée",
      "total-revenue": "CA généré",
      "total-revenue-hint": "Montant total des transactions ayant généré du cashback sur la plage de date observée",
      "average-basket": "Panier moyen",
      "average-basket-hint": "Montant moyen des transactions ayant généré du cashback sur la plage de date observée (CA généré / Nombre de récompenses)",
      "number-of-rewards": "Nombre de récompenses",
      "number-of-rewards-hint": "Nombre total de cashbacks générés sur la plage de date observée",
      "reward-amount": "Montant des récompenses",
      "reward-amount-hint": "Montant total des cashbacks générés sur la plage de date observée",
      "average-reward-amount": "Récompense moyenne",
      "average-reward-amount-hint": "Montant moyen d'un cashback sur la plage de date observée (Montant des récompenses / Nombre de récompenses)",
      "total-discounts": "Total réductions",
      "total-discounts-hint": "Montant total des réductions de vouchers générées sur la plage de date observée",
      "total-fees": "Total frais",
      "total-fees-hint": "Montant total des frais générés sur la plage de date observée",
      "total-vouchers": "Total vouchers",
      "total-vouchers-hint": "Nombre total de vouchers émis sur la plage de date observée",
      "total-voucher-value": "Valeur totale des vouchers",
      "total-voucher-value-hint": "Valeur faciale totale des vouchers émis sur la plage de date observée",
      "total-voucher-sell": "Valeur totale de ventes de vouchers",
      "total-voucher-sell-hint": "Montant total payé par les consommateurs pour l'achat des vouchers sur la plage de date observée",
      "total-voucher-discount": "Réduction totale des vouchers",
      "total-voucher-discount-hint": "Montant total des réductions de vouchers générées sur la plage de date observée",
      "total-voucher-commission": "Commission totale des vouchers",
      "total-voucher-commission-hint": "Montant total des commissions générées sur les vouchers sur la plage de date observée",
      "rewards-per-merchant": "Nombre de récompenses par marchand",
      "reward-amount-per-brand": "Montant des récompenses par marchand",
      "average-reward-amount-per-brand": "Montant moyen de récompense par marchand",
      "commission-per-brand": "Commission par marchand",
      "vouchers-per-brand": "Nombre de vouchers par marchand",
      "voucher-discount-per-brand": "Montant des récompenses par marchand",
      "voucher-commission-per-brand": "Commission de vouchers par marchand",
      "total-gifts": "Total cadeaux",
      "total-gifts-hint": "Nombre total de cadeaux distribués sur la plage de date observée",
      "total-gifts-amount": "Montant total des cadeaux",
      "total-gifts-amount-hint": "Montant total des cadeaux distribués sur la plage de date observée",
      "total-activated-gifts": "Total cadeaux activés depuis toujours",
      "total-activated-gifts-hint": "Nombre total de cadeaux activés par les utilisateurs",
      "total-unique-coupons": "Total coupons uniques",
      "total-unique-coupons-hint": "Nombre total de coupons uniques créés sur la plage de date observée",
      "total-unique-activated-coupons": "Total coupons uniques activés",
      "total-unique-activated-coupons-hint": "Nombre total de coupons uniques activés par les utilisateurs",
      "total-generic-coupons": "Total coupons génériques",
      "total-generic-coupons-hint": "Nombre total de coupons génériques créés sur la plage de date observée",
      "total-generic-activated-coupons": "Total coupons génériques activés",
      "total-generic-activated-coupons-hint": "Nombre total de coupons génériques activés par les utilisateurs",
    },
    "leaderboard": {
      "count": "Nombre",
      "amount": "Montant (€)",
      "brand-name": "Nom de l'enseigne",
      "show-all": "Tout voir",
      "show-less": "Voir moins",
    },
    "status": {
      "heading": "Tableau de bord",
      "welcome": {
        "heading": "Bienvenue !",
        "text": "Bienvenue dans votre tableau de bord ! Vous pourrez y observer la performance de vos campagnes, les habitudes de consommation de vos clients, ainsi que tout un ensemble d’indicateurs calculés par nos moteurs. Il reste encore quelques actions pour déployer le plein potentiel de PayLead Cube !"
      },
      "action1": {
        "heading": "Documents",
        "text": "Afin de commencer à utiliser le programme de fidélité, envoyez vos documents légaux.",
        "button": "Envoyer mes documents",
      },
      "action2": {
        "heading": "Prélèvement",
        "text": "Vous ne serez facturé que si le programme vous génère du chiffre d’affaires.",
        "button": "Accepter le prélèvement",
      },
      "action3": {
        "heading": "Mes Magasins",
        "text": "Ajouter vos magasins pour des offres et des statistiques plus précises.",
        "button": "Ajouter des magasins",
      },
      "action4": {
        "heading": "Mes Statistiques",
        "text": "Générons vos statistiques à partir des transactions de vos clients !",
        "button": "Identifiez les transactions",
      },
      "action5": {
        "heading": "Première Offre",
        "text": "Créez une première offre et gagnez de nouveaux clients !",
        "button": "Créer ma première offre",
      }
    }
  },

  // Marketplace

  "campaigns": {
    "list": {
      "tab": {
        "available": "A traiter",
        "accepted": "Acceptées",
        "rejected": "Rejetées",
        "all": "Toutes",
      },
      "heading": "Campagnes",
      "empty": "Aucune stratégie disponible…",
    },
    "details": {
      "heading": "Campagne",
      "heading.campaign": "Campagne",
      "heading.offers": "Offres",
      "heading.guidelines": "Indications",
      "heading.commission-group": "Groupes de commissions",
      "heading.vouchers": "Vouchers",
      "heading.targeting": "Ciblage",
      "heading.terms": "Conditions légales",
      "button.create": "Ajouter une offre",
      "empty": "Vous devez créer une offre à partir de cette campagne…",
      "empty-warning": "Ajouter une offre à cette campagne la passera en 'Acceptée'.",
      "empty-targeting": "Cette campagne est générique.",
      "lookalike-targeting": "Audience lookalike",
      "specific-targeting": "Specific audience",
      "specific-targeting-hint": "Audience construite à partir d'une liste de clients fournie par la marque. Pour plus de détails sur cette audience, contactez le support.",
    },
    "form": {
      "heading": "Campagne",
    },
    "objectives": {
      "LOYALTY": "Fidélisation",
      "AVERAGE_BASKET": "Panier moyen",
      "MARKET_SHARE": "Parts de marché",
      "OMNICHANNEL": "Omnicanalité",
      "ACQUISITION": "Acquisition",
      "CUSTOM": "Personnalisé",
    },
    "shared": {
      "channel.ONLINE": "En ligne",
      "channel.OFFLINE": "En magasin",
      "channel.BOTH": "En ligne + En magasin",
      "dialog.confirm-reject": "Etes-vous sûr de rejeter cette campagne ?",
      "apply-guidelines": "Appliquer les indications",
      "only-reward-transactions": "N'appliquer les rewards que sur les transactions de {source}",
      "custom-date": "Personnaliser les dates",
      "commission-share": "Commission moyenne",
      "form.success.renamed": "Commission renommée avec succès.",
      "summary": {
        "current-state": "État courant",
        "remaining-time": "Temps restant",
        "remaining-time-count": "{ nb, plural, =0 {# jour} =1 {# jour} other {# jours} }",
        "remaining-day-left-count": "{ nb, plural, =0 {# jour restant} =1 {# jour restant} other {# jours restants} }",
        "no-more-budget": "Le budget initial de { value } a été atteint.",
        "no-more-time": "Cette campagne s’est terminée le { date }",
        "cancelled": "Cette campagne a été annulée.",
        "published": "Publiée",
        "publication": "Publication",
        "activation": "Activation",
        "waiting-publication": "Attente de publication",
        'ended-completed': 'Le budget de la campagne a été épuisé le {date}.',
        'ended-deactivated': 'La campagne a été désactivée le {date}.'
      },
    }
  },

  // Reports

  "reports": {
    "list": {
      "heading": "Reporting",
      "empty": "Aucun résultat…",
      "empty-results": "Aucun résultat avec ces filtres…",
      "metrics-reward-amount": "Montant des rewards",
      "metrics-total-commissions": "Total des commissions",
      "metrics-total-consumers": "Total des consommateurs",
      "metrics-total-rewards": "Total des rewards",
      "metrics-total-vouchers": "Total des vouchers",
      "metrics-voucher-amount": "Montant des vouchers",
      "metrics-voucher-funds": "Budget voucher restant",
      "metrics-voucher-revenue": "Total des revenus",
    },
    "shared": {
      "brand": "Enseigne",
      "created-at": "Créé",
      "offer-reference": "Réf. offre",
      "consumer-id": "Consumer ID",
      "executed-at": "Executé",
      'strategy-reference': 'Campagne',
      "transaction-amount": "Transaction",
      "reward-rate": "Taux reward",
      "reward-amount": "Reward",
      "commission": "Commission",
      "updated-at": "Mis à jour",
      "campaign": "Campagne",
      "status": "Statut",
      "technical-status": "Statut technique",
      "consumer-status": "Statut consommateur",
      "offer": "Offre",
      "type": "Type",
      "strategy": "Strategie",
      "invoice": "Facture",
      "original-price": "Prix",
      "value": "Valeur",
      "total-fees": "Commission",
      "paylead-fees": "Com. PayLead",
      "price": "Prix cons.",
      "program-fees": "Revenus",
      "only-paid": "Vouchers payés uniquement",
      "only-valid": "Rewards valides uniquement",
      "apply-filters": "Appliquer les filtres",
      "reset-filters": "Reset",
      "types": {
        "CASHBACK": "ALO Rewards",
        "CASHBACK_AFFILIATION": "Affiliation Rewards",
        "GIFT": "Dons",
        "COUPON": "Coupons",
        "VOUCHER": "Vouchers",
        "AWIN": "Transactions Awin",
        "LBS_CASHBACK": "Reward LBS",
        "EVO_CASHBACK": "Cashback voucher"
      },
      "tabs": {
        "rewards": "Rewards",
        "vouchers": "Vouchers",
      }
    }
  },

  // Offers

  "offers": {
    "list": {
      "tab": {
        "currently": "En cours",
        "ended": "Terminées",
        "all": "Toutes",
        "pending": "En attente",
        "active": "En cours",
        "published": "Publiées",
      },
      "heading": "Offres",
      "empty": "Aucune offre disponible…",
      "button.create": "Créer une offre",
      "is-ab-tested": "Groupe de contrôle",
      "is-targeted": "Cette offre est ciblée",
      "is-main-source-transaction": "Cette offre récompense les transactions {source}",
      "is-no-phase": "Cette offre n’est pas partagée à vos clients car elle n’a actuellement pas de phase active en cours. Veuillez en ajouter une pour qu’elle apparaisse à vos clients.",
      "is-frequency": "Récompense la fréquence d’achats ({frequency})"
    },
    "preview": {
      "heading": "Offres",
      "heading.essential": "L’Essentiel",
      "heading.quickedit": "Quick edit",
      "form.success": "Offre éditée avec succès",
      "status.ONLINE": "Offre en ligne uniquement",
      "status.OFFLINE": "Offre en magasin uniquement",
      "status.BOTH": "Offre en ligne et en magasin",
      "application.placeholder.url": "URL permettant de bénéficier de l’offre en ligne…",
      "dialog.deactivate.text": "Désactiver cette offre sera définitif après sauvegarde.",
      "phases.heading.evolution": "Evolution du taux de Reward",
      "phases.button.delete": "Supprimer",
      "phases.button.adjust": "Modifer",
      "phases.button.details": "Détails",
      "phases.button.add": "Ajouter une modification",
      "phases.empty": "Pas d’évolution du taux de reward prévues"
    },
    "metrics": {
      "heading": "Performance",
      "heading-hint": "Performance sur la période observée",
      "heading.activations": "Nombre de participants actifs",
      "heading.activations-hint": "Nombre de participants sur la période observée",
      "heading.average-spend": "Dépenses moyennes",
      "heading.average-spend-hint": "Dépenses moyennes des participants sur la période observée",
      "heading.average-spent": "Paniers moyens",
      "heading.average-spent-hint": "Paniers moyens des participants sur la période observée",
      "heading.cashback": "Montant et nombre total des Rewards",
      "heading.cashback-hint": "Ce graphique illustre le nombre (disque) et le montant total des rewards versés au cours du temps, sur la période observée",
      "heading.commissions": "Commissions",
      "heading.commissions-hint": "Commissions générées sur la période observée",
      "heading.overtime": "Activité",
      "heading.overtime-hint": "Un ensemble de graphiques permettant d’évaluer votre popularité",
      "heading.performance": "Performance",
      "heading.performance-hint": "Performance sur la période observée",
      "heading.total-spend": "Chiffre d’affaires généré",
      "heading.total-spend-hint": "Chiffre d’affaires généré par l’offre sur la période",
      "heading.total-spent": "Chiffre d’affaires généré",
      "heading.total-spent-hint": "Chiffre d’affaires généré par l’offre sur la période",
      "from-beginning-to": "Du commencement de l'offre au { end }",
      "load-error": "Les indicateurs n’ont pas pu être chargés. Rechargez la page ou réessayez plus tard…"
    },
    "form": {
      "recipient.network": "L’offre est valable dans tous les magasins du réseau :",
      "recipient.brand": "L’offre est valable dans tous les magasins de l’enseigne :",
      "recipient.stores": "L’offre est valable dans tous les magasins suivants :",
    },
    "dialog": {
      "reward-move": {
        "heading": "Ajout d'une phase de Reward",
        "heading.edit": "Edition de la phase de Reward",
      }
    },
    "shared": {
      "label": {
        "funded-by": "Is funded by",
        "offer-active": "Active",
        "offer-inactive": "Inactive",
        "target-help": "Affinez l’audience cible de cette offre par filtrage de différents critères démographiques.",
        "target-error-brand-count": "Doit inclure au moins {count} enseignes différentes.",
        "custom": "Personnaliser",
        "end_date": "Date de fin",
        "deactivated_at": "Date de désactivation",
        "completed_at": "Date completed",
        "end-date": "Offre expirée",
        "deactivated-at": "Offre désactivée",
        "completed-at": "Budget atteint",
      },
      "summary": {
        "heading": "Résumé",
        "checklist": {
          "details": "Détails de l’offre",
          "target": "Ciblage",
          "terms": "Conditions légales",
          "published": "Publication le ",
        },
        "current-state": "État courant",
        "current-state-hint": "Changement définitif",
        "remaining-time": "Temps restant",
        "remaining-time-count": "{ nb, plural, =0 {# jour} =1 {# jour} other {# jours} }",
        "remaining-budget": "Budget restant",
        "remaining-coupons": "Coupons restants",
        "remaining-day-left-count": "{ nb, plural, =0 {# jour restant} =1 {# jour restant} other {# jours restants} }",
        "no-more-budget": "Le budget initial de { value } a été atteint.",
        "no-more-time": "Cette offre s’est terminée le { date }",
        "cancelled": "Cette offre a été annulée.",
        "published": "Publiée",
        "waiting-publication": "Attente de publication",
        "publication": "Publication",
        "activation": "Activation",
      },
      "types": {
        'ALL': 'Tous',
        "UNIQUE_COUPON": "Coupon unique",
        "GENERIC_COUPON": "Coupon générique",
        "CASHBACK": "Reward",
        "AFFILIATION": "Affiliation",
        "VOUCHER": "Voucher",
        "LBS_CASHBACK": "Reward LBS"
      }
    }
  },

  // Coupons

  "coupons": {
    "list": {
      "tab": {
        "currently": "En cours",
        "ended": "Terminés",
        "pending": "En attente",
        "all": "Tous",
        "active": "En cours",
      },
      "heading": "Coupons",
      "empty": "Aucun coupon disponible…",
      "button.create": "Créer un coupon"
    },
    "generic": {
      "form": {
        "heading": "Coupon générique",
        "heading.essential": "L’essentiel",
        "heading.terms": "Conditions légales",
      }
    },
    "unique": {
      "form": {
        "heading": "Coupon unique",
        "heading.essential": "L’essentiel",
        "heading.terms": "Conditions légales",
        "hint.coupon-file": "Fichier CSV avec un code par ligne",
        "hint.coupon-amount": "Auto généré"
      }
    },
    "metrics": {
      "heading": "Performance",
      "heading-hint": "Performance sur la période observée",
      "heading.activations": "Nombre de participants actifs",
      "heading.activations-hint": "Nombre de participants sur la période observée",
      "heading.average-spend": "Dépenses moyennes",
      "heading.average-spend-hint": "Dépenses moyennes des participants sur la période observée",
      "heading.average-spent": "Paniers moyens",
      "heading.average-spent-hint": "Paniers moyens des participants sur la période observée",
      "heading.cashback": "Montant et nombre total des Rewards",
      "heading.cashback-hint": "Ce graphique illustre le nombre (disque) montant total (ordonnées) des Rewards versés au cours du temps sur la période observée",
      "heading.commissions": "Commissions",
      "heading.commissions-hint": "Commissions versées à Paylead sur la période observée",
      "heading.overtime": "Activité",
      "heading.overtime-hint": "Un ensemble de graphiques permettant d’évaluer votre popularité",
      "heading.performance": "Performance",
      "heading.performance-hint": "Performance sur la période observée",
      "heading.total-spend": "Chiffre d’affaires généré",
      "heading.total-spend-hint": "Chiffre d’affaires Généré par l’offre sur la période",
      "heading.total-spent": "Chiffre d’affaires généré",
      "heading.total-spent-hint": "Chiffre d’affaires Généré par l’offre sur la période",
    },
    "form": {
      "header.multistore": "Multiple",
      "heading.terms": "Conditions légales",
      "heading.application": "Canal",
      "recipient.network": "Le coupon est valable dans tous les magasins du réseau :",
      "recipient.brand": "Le coupon est valable dans tous les magasins de l’enseigne :",
      "recipient.stores": "Le coupon est valable dans tous les magasins suivants :",
      "application.placeholder.url": "Merci d’indiquer l’URL permettant de bénéficier de l’offre en ligne…",
      "date-start-past": "A débuté le { date } à { time } (Paris)",
      "date-start-future": "Débutera le { date } à { time } (Paris)",
      "date-end-past": "S’est terminée le { date } à { time } (Paris)",
      "date-end-future": "Se terminera le { date } à { time } (Paris)",
      "form.success": "Coupon édité avec succès.",
      "no-editable-fields": "Cette offre est terminée. Elle ne peut être modifée.",
      "no-editable-fields-reactivable": "Cette offre est désactivée. Elle ne peut être modifée.",
    },
    "selection": {
      "heading": "Coupons / Sélectionner",
      "heading.choose": "Choisissez un type de coupon :",
      "action1": {
        "heading": "Coupons génériques",
        "text": "Offre à code simple réutilisable comme par ex. « NOEL20 » entré par l’utilisateur lors de l’achat en ligne.",
        "button": "Créer offre à coupon générique",
      },
      "action2": {
        "heading": "Coupons uniques",
        "text": "Offre à coupon (QR Code, Code Barre ou simple) généré pour les utilisateurs, à présenter en caisse lors de l’achat pour bénéficier de la réduction.",
        "button": "Créer offre à coupon unique",
      }
    },
    "recipients": {
      "heading": "Coupons / Bénéficiaires",
      "heading.choose": "Choisissez les bénéficiaires",
      "search-store": "Rechercher un magasin…",
      "search-brand": "Rechercher une enseigne…",
      "search-network": "Rechercher un réseau…",
      "empty": "Aucun bénéficiaire trouvé",
      "empty-cart": "Aucun élément sélectionné",
      "select-hint": "Sur cette page",
      "store-count": "{ nb, plural, =0 {Aucun magasin} =1 {# magasin} other {# magasins} }",
    },
    "dialog": {
      "publication-date": {
        "heading": "Publication du coupon",
        "choice-1": "Dès que possible (demain)",
        "choice-2": "À une date et heure ultérieure"
      }
    },
    "shared": {
      "label": {
        "funded-by": "Financé par",
        "coupon-active": "Actif",
        "coupon-inactive": "Inactif"
      },
      "summary": {
        "heading": "Résumé",
        "checklist": {
          "details": "Détails du coupon",
          "target": "Ciblage",
          "terms": "Conditions légales",
          "published": "Publication le ",
        },
        "current-state": "État courant",
        "current-state-hint": "Changement définitif",
        "remaining-time": "Temps restant",
        "remaining-time-count": "{ nb, plural, =0 {# jour} =1 {# jour} other {# jours} }",
        "remaining-budget": "Budget restant",
        "remaining-coupons": "Coupons restants",
        "remaining-day-left-count": "{ nb, plural, =0 {# jour restant} =1 {# jour restant} other {# jours restants} }",
        "no-more-budget": "Le budget initial de { value } a été atteint.",
        "no-more-time": "Ce coupon s’est terminée le { date }",
        "cancelled": "Ce coupon a été annulée.",
        "published": "Publiée",
        "waiting-publication": "Attente de publication",
        "publication": "Publication",
        "activation": "Activation",
      },
      "types": {
        "UNIQUE_COUPON": "Coupon unique",
        "GENERIC_COUPON": "Coupon générique"
      }
    }
  },

  // Consumers

  "consumers": {
    "list": {
      "heading": "Consommateurs",
      "empty": "Aucun consommateur pour le moment…",
      "tab": {
        "all": "Tous",
        "active": "Actifs",
        "inactive": "Inactifs",
      },
    },
    "details": {
      "heading": "Consommateur",
      "heading.details": "Détails du consommateur",
      "heading.activity": "Activité du consommateur",
      "tab.activities": "Activités",
      "tab.offers": "Offres",
      "tab.cashbacks": "Rewards",
      "tab.transfers": "Transferts",
      "tab.vouchers": "Vouchers",
      "tab.connections": "Synchronisations",
      "table.technical-status": "Statut technique",
      "table.consumer-status": "Statut consommateur",
      "empty.offers": "Aucune offre pour le moment…",
      "empty.cashbacks": "Aucun reward pour le moment…",
      "empty.transfers": "Aucun transfert pour le moment…",
      "empty.activities": "Aucune activité pour le moment…",
      "empty.connections": "Aucune connexion pour le moment…",
      "total-cashback": "Montant total des rewards en ”{status}”",
      "minimum-trigger": "{amount} minimum pour déclencher la cagnotte",
      "optout-hint": "Opt-out",
      "optout-confirm": "Veuillez confirmer le retrait du consentement <strong>{level}</strong> du consommateur <strong>{consumer}</strong>.",
      "not-found": "Aucun consommateur n‘a été trouvé avec cet ID…",
      "empty": "Entrez un Consumer ID dans le champs de recherche.",
    },
    "cashback": {
      "heading.details": "Détails du reward",
      "heading.history": "Historique du reward",
      "heading.attributions": "Attributions",
      "heading.status-history": "Historique des statuts",
      "status-history.date": "Date",
      "status-history.kind": "Statut",
      "status-history.previous-status": "Ancien statut",
      "status-history.new-status": "Nouveau statut",
      "status-history.origin": "Origine",
      "status-history.kind-TECHNICAL": "Technique",
      "status-history.kind-CONSUMER": "Consommateur",
      "status-history.origin-AUTO": "Auto",
      "status-history.origin-API": "API",
      "status-history.origin-UNKNOWN": "Inconnue",
    },
    "voucher": {
      "heading.details": "Détails du voucher",
      "heading.history": "Historique du voucher",
      "heading.content": "Contenu du voucher",
      "heading.downloads": "Téléchargement du voucher",
      "download": "Téléchargé par",
      "content.updated-at": "Voucher mis à jour le",
      "content.card-number": "Card Number (EAN ou QR)",
      "content.pin-code": "Card Pin",
      "content.card-url": "Card URL",
      "content.card-pdf": "PDF"
    },
    "transfer": {
      "heading.details": "Détails du Transfert"
    }
  },

  // Consumer events

  "consumer-events": {
    "list": {
      "heading": "Evénements de vie",
      "empty": "Aucun événenement pour le moment…",
      "button.create": "Créer un événement",
    },
    "form": {
      "heading": "Événements de vie / Éditer",
      "heading.info": "Informations",
      "heading.details": "Détails de l'Événements",
      "heading.configuration": "Configuration",
      "heading.detection": "Détection de transactions",
      "heading.detection-hint": "Si vide, toutes les transactions seront examinées.",
      "heading.simulation": "Simulation",
      "heading.time-period": "Périodes",
      "heading.monthly-aggregation": "Agrégation mensuelle",
      "heading.period-aggregation": "Agrégation des périodes",
      "heading.conditions": "Conditions",
      "tab.one-period": "Période simple",
      "tab.one-period.hint": "Détection d'un état par rapport à un seuil",
      "tab.two-periods": "Périodes comparées",
      "tab.two-periods.hint": "Détection de changements en comparant deux périodes",
      "text.simulation": "Il est possible de lancer une simulation sur les comportements des consommateurs avant d'activer cet Évènement.",
      "form.success": "Evènement édité avec succès.",
      "including": "Comprenant",
      "excluding": "Ne comprenant pas",
      "placeholder.label": "Saisissez un label et pressez Entrée",
      "placeholder.never": "Jamais",
      "placeholder.no-start-day": "Aucun",
      "button.add-condition": "Ajouter une condition",
      "monthly-aggregation": "Agrégation mensuelle",
      "monthly-aggregation.hint": "Méthode d'agrégation de toutes les transactions détectées au cours d'un mois.",
      "observation-value": "Valeur d'Observation",
      "observation-aggregation": "Agrégation d'Observation",
      "observation-aggregation.hint": "Méthode d'agrégation des mois de la période d'Observation. Le résultat se nommera “Valeur d'Observation“.",
      "confirmation-value": "Valeur de Confirmation",
      "confirmation-aggregation": "Agrégation de Confirmation",
      "confirmation-aggregation.hint": "Méthode d'agrégation des mois de la période de Confirmation. Le résultat se nommera “Valeur de Confirmation.",
      "confirm-tab-change": "Certaines de vos confitions contiennent une périodes d'Observation. Ceci est incompatible avec le mode “Période Simple“. Ces conditions seront supprimées.",
      "periods-observation": "Période d'Observation",
      "periods-gap": "Écart",
      "periods-confirmation": "Période de Confirmation",
      "months-consecutive": "mois consécutifs",
      "months-no-data": "les mois sans données",
      "months-between-periods": "mois entre la période d'Observation et de Confirmation",
      "condition-nb": "Condition { nb }",
      "custom-value": "Personnalisées",
      "start-day": "Jour du mois de départ",
      "expiration-delay": "Délais d'expiration (en mois)",
    },
    "logs": {
      "heading": "Journal des Evènements",
      "heading.name": "Journal de { name }",
      "heading.details": "Détails",
      "empty": "Aucun événenement pour le moment…",
      "tab.summary": "Résumé",
      "tab.overtime": "Overtime des Occurrences",
    },
    "shared": {
      "delete": {
        "title": "Supprimer cet Événement ?",
        "text": "La suppression est définitive. Cette action est irréversible."
      },
      "operator": {
        "GT": "Supérieure à",
        "LT": "Inférieure à",
      }
    },
  },

  // Rewards

  "rewards": {
    "list": {
      "heading.cashbacks": "Rewards",
      "heading.gifts": "Dons",
      "empty": "Aucune données pour le moment…",
      "tab": {
        "all": "Tous",
        "paid-out": "Payé",
        "paid-in": "Cagnotte",
        "validated": "Validé",
        "pending": "En attente",
      },
    },
    "details": {
      "heading.cashbacks": "Reward",
      "heading.gifts": "Don",
      "heading.details": "Détails",
      "heading.history": "Historique"
    },
    "dialog": {
      "import": {
        "heading": "Import par CSV",
        "message": "Uploadez un fichier CSV avec un CONSUMER_ID;AMOUNT;REWARD_NAME par ligne. Séparés par un point-virgule.",
        "errors": "Il y a {errors, plural, =1 {# erreur} other {# erreurs} } dans ce fichier CSV.",
        "form.success": "Fichier en cours d’importation… Cela peut prendre plusieurs minutes. Vous serez informé en cas d’erreur.",
      }
    },
    "shared": {
      "type": {
        "GIFT": "Cadeau",
        "CASHBACK": "Reward",
        "CASHBACK_AFFILIATION": "Affiliation",
        "LBS_CASHBACK": "Reward LBS",
        "EVO_CASHBACK": "Cashback voucher"
      }
    }
  },

  // ventilations

  "ventilations": {
    "list": {
      "heading": "Ventilation",
      "empty": "Aucune ventilation pour le moment…",
      "tab": {
        "all": "Tous",
        "paid-out": "Payé",
        "paid-in": "Cagnotte",
        "validated": "Validé",
        "pending": "En attente",
      },
    },
    "details": {
      "heading": "Ventilation",
      "heading.details": "Détails de la Ventilation",
      "heading.history": "Historique de la Ventilation",
    },
    "shared": {
      "type": {
        "GIFT": "Cadeau",
        "CASHBACK": "Reward",
      },
      "table": {
        "fee_invoice_reference": "Référence de facture",
        "invoicing_cycle": "Cycle (AAAA-MM)",
        "amount": "Montant total à ventiler",
        "payout": "Référence de paiement",
      }
    }
  },

  // affiliaton ventilations

  "affiliation_ventilations": {
    "list": {
      "heading": "Ventilation d'affiliation",
      "empty": "Aucune ventilation d'affiliation pour le moment…",
    },
    "shared": {
      "table": {
        "invoicing_cycle": "Cycle de facturation",
      }
    }
  },

  // Transactions

  "transactions": {
    "list": {
      "heading": "Transactions",
      "empty": "Aucune transaction disponible…",
    },
    "details": {
      "heading": "Transactions",
      "heading.payment": "Paiement",
      "heading.status": "Statut",
      "heading.information": "Informations",
      "heading.client": "Client",
      "button.cancel": "Annuler cette transaction",
      "cashback-cancelled": "Cette transaction a été annulée :"
    },
    "dialog": {
      "status": {
        "heading": "Annulation de reward",
        "text":
          `Vous êtes sur le point d’annuler ce reward client.
          <b>Cette action est définitive</b>.
          Merci d’indiquer la raison de cette annulation.`
      }
    }
  },

  // Segments

  "segments": {
    "list": {
      "heading": "Segments",
      "empty": "Aucun segment disponible…",
      "button.import": "Assigner consommateurs",
      "table.consumers": "Consommateurs",
      "button.export": "⬇ Télécharger la liste",
      "export.async": "Ce segment est volumineux : le fichier sera disponible depuis le suivi des imports.",
      "export.error": "Une erreur est survenue pendant le téléchargement de la liste.",
    },
    "dialog": {
      "import": {
        "heading": "Import par CSV",
        "message": "Uploadez un fichier CSV avec un CONSUMER_ID;SEGMENT_ID par ligne. Séparés par un point-virgule.",
        "errors": "Il y a {errors, plural, =1 {# erreur} other {# erreurs} } dans ce fichier CSV.",
        "form.success": "Fichier en cours d’importation… Cela peut prendre plusieurs minutes. Vous serez informé en cas d’erreur.",
        "template.heading": "Modèle attendu",
        "template.download": "⬇ Télécharger le modèle .csv",
        "template.comment": "ligne d’en-tête obligatoire",
        "header.warning": "Le fichier ne commence pas par la ligne d’en-tête consumer_id;slug. Il sera tout de même traité (compatibilité avec les fichiers sans en-tête).",
      }
    },
    "imports": {
      "heading": "Suivi des imports",
      "empty": "Aucun import déclenché sur les dernières 24 h.",
      "last-refresh": "Dernière actualisation à {time}",
      "button.refresh": "Rafraîchir",
      "table": {
        "id": "Import",
        "status": "Statut",
        "triggered": "Déclenché",
        "completed": "Terminé",
        "result": "Résultat",
        "report": "Rapport",
        "ok": "ok",
        "ko": "KO",
        "download-report": "⬇ Rapport",
      },
      "status": {
        "WAITING": "En attente",
        "RUNNING": "En cours",
        "SUCCESS": "Terminé",
        "FAILURE": "Échec",
      }
    },
  },

  // Invoices

  "invoices": {
    "list": {
      "heading": "Factures",
      "empty": "Aucune facture disponible…",
      "tab": {
        "all": "Tous",
        "gifts": "Dons",
        "fees": "Commissions",
        "deposits": "Budget voucher",
        "vouchers": "Vouchers",
      },
      "type": {
        "GIFT": "Don",
        "FEE": "Commission",
        "VOUCHER_PRICES": "Voucher",
        "VOUCHER_FEES": "Commission voucher",
        "VOUCHER_DEPOSIT": "Budget voucher",
      }
    },
    "charts": {
      "subscribers-evolution": "Évolution des souscriptions",
      "churners-evolution": "Évolution des désinscriptions",
      "rewarded-consumers": "Consommateurs récompensés",
      "reward-amount-commission": "Montant des récompenses + commission",
      "number-of-rewards": "Nombre de récompenses",
      "voucher-discount": "Somme des réductions de vouchers",
      "voucher-by-consumers": "Vouchers par consommateur",
      "vouchers": "Vouchers",
      "labels": {
        "subscriptions": "Inscriptions",
        "cumulative-subscriptions": "Inscriptions cumulées",
        "churners": "Désinscriptions",
        "cumulative-churners": "Désinscriptions cumulées",
        "rewarded": "Récompensés",
        "program-fees": "Commissions",
        "reward-amount": "Montant récompenses",
        "discount": "Réduction",
        "fees": "Frais",
        "count": "Nombre",
      },
    },
    "metrics": {
      "total-subscribers": "Total souscriptions",
      "total-subscribers-hint": "Nombre total d'inscriptions au programme depuis le lancement",
      "total-churners": "Total désinscriptions",
      "total-churners-hint": "Nombre total d'utilisateurs qui se sont désabonnés du programme depuis le lancement",
      "total-onboarded": "Total inscrits",
      "total-onboarded-hint": "Nombre total d'utilisateurs enregistrés dans le programme à ce jour",
      "total-rewarded": "Total récompensés",
      "total-rewarded-hint": "Nombre total d'utilisateurs ayant généré du cashback depuis le lancement du programme",
      "total-playground": "Total playground",
      "total-playground-hint": "Montant total des revenus (cashbacks + commissions) générés depuis le lancement du programme",
      "total-commission": "Total commission",
      "total-commission-hint": "Montant total des commissions générées depuis le lancement",
      "number-of-rewards": "Nombre de récompenses",
      "number-of-rewards-hint": "Nombre total de cashbacks générés depuis le lancement",
      "reward-amount": "Montant des récompenses",
      "reward-amount-hint": "Montant total des cashbacks générés depuis le lancement",
      "total-discounts": "Total réductions",
      "total-discounts-hint": "Montant total des réductions de vouchers générées depuis le lancement",
      "total-fees": "Total frais",
      "total-fees-hint": "Montant total des frais générés depuis le lancement",
      "total-vouchers": "Total vouchers",
      "total-voucher-value": "Valeur totale des vouchers",
      "total-voucher-sell": "Ventes totales de vouchers",
      "total-voucher-discount": "Réduction totale des vouchers",
      "total-voucher-commission": "Commission totale des vouchers",
      "rewards-per-merchant": "Nombre de récompenses par marchand",
      "reward-amount-per-brand": "Montant des récompenses par enseigne",
      "commission-per-brand": "Commission par enseigne",
    },
    "status": {
      "UPDATED": "Mise à jour",
      "REGENERATED": "Re-générée",
      "GENERATED": "Générée",
    }
  },

  // Users

  "users": {
    "list": {
      "heading": "Mon compte / Utilisateurs",
      "empty": "Aucun utilisateur disponible…",
      "button.create": "Inviter un utilisateur",
    },
    "form": {
      "heading": "Mon compte / Utilisateurs / Éditer",
      "heading.user": "Utilisateur",
      "form.success": "Utilisateur édité avec succès.",
      "form.deactivate-user.success": "Utilisateur désactivé avec succès.",
      "form.deactivate-user.error": "Une erreur est survenue lors de la désactivation de l'utilisateur.",
      "button.deactivate-user": "Désactiver l'utilisateur"
    },
    "invite": {
      "heading": "Mon compte / Utilisateurs / Inviter",
      "heading.user": "Utilisateur à inviter",
      "hint": "Une invitation sera envoyée avec les instructions de création de compte.",
      "form.success": "L’utilisateur va recevoir un email d’invitation."
    }
  },

  // merchants

  "merchants": {
    "form": {
      "heading": "Mon compte / Enseigne",
      "heading.merchant": "Enseigne",
      "heading.picture": "Logo",
      "heading.visuals": "Visuels",
      "form.success": "Les données de votre Enseigne ont été mises à jour.",
    },
    "selector": {
      "heading": "Choisissez un marchand"
    }
  },

  // Shops

  "stores": {
    "list": {
      "heading": "Mon compte / Magasins",
      "heading.store": "Magasin",
      "button.create": "Ajouter un magasin",
      "empty": "Vous n’avez pas encore de magasins.",
      "api.not-found": "Nous ne trouvons pas cette entreprise"
    },
    "form": {
      "heading": "Mon compte / Magasins / Ajouter un magasin",
      "heading.info": "Information sur le point de vente",
      "heading.opening-times": "Horaires d’ouverture",
      "heading.affiliations": "Affiliations",
      "card-payment-ticket": "Ticket de paiement par carte",
      "add-opening-times": "Ajouter",
      "closed": "Fermé",
      "coords": {
        "find": "Trouver ces coordonnées à partir de l’adresse saisie ?",
        "drag": "Vous pouvez déplacer le enseigneur pour ajuster la position."
      },
      "warning.affiliates": "Voici la liste des marchands partenaires qui peuvent envoyer des offres sur votre point de vente. Si vous constatez une anomalie, n’hésitez pas à contacter notre support.",
      "form.success": "Magasin mis à jour."
    },
    "dialog": {
      "import": {
        "heading": "Import de magasins par CSV",
        "message": "Uploadez un fichier CSV avec un Siret et un nom de magasin par ligne. Séparés par une virgule. 1ère ligne (header) ignorée.",
        "errors": "Il y a {errors, plural, =1 {# erreur} other {# erreurs} } dans ce fichier CSV.",
        "form.success": "Magasins importés avec succès.",
      }
    }
  },

  // Payments

  "payments": {
    "form": {
      "heading": "Mon compte / Moyens de paiement",
      "heading.methods": "Moyens de paiement",
      "tabs": {
        "bank-account": "Compte bancaire",
        "credit-card": "Carte de crédit",
      },
      "form.success": "Votre compte a été mis à jour.",
    },
  },

  // Settings

  "settings": {
    "form": {
      "heading": "Mon compte / Paramètres",
      "heading.settings": "Paramètres",
      "heading.notifications": "Notifications",
      "heading.password": "Changer le mot de passe",
      "form.success": "Vos paramètres ont été mis à jour.",
    },
  },

  // Programs

  "programs": {
    "form": {
      "heading": "Mon compte / Programme",
      "heading.program": "Programme",
      "heading.terms": "Conditions légales",
      "form.success": "Votre programme a été mis à jour.",
    },

    "performances": {
      "heading": "Tableau de bord",
      "heading.funnel": "Activité des consommateurs",
      "heading.rewards-merchants": "Distribution",
      "heading.accounts-created": "Création du compte",
      "heading.accounts-created-hint": "Nouveaux consommateurs (basé sur la date de création du compte)",
      "heading.accounts-connected": "Connexion aux comptes bancaires",
      "heading.accounts-connected-hint": "Consommateurs ayant connecté au moins un compte bancaire (basé sur la date de connexion du premier compte bancaire)",
      "heading.transactions-shared": "Partage des transactions",
      "heading.transactions-shared-hint": "Consommateurs ayant effectué au moins une transaction éligible aux rewards (basé sur la date d'exécution de la transaction)",
      "heading.statuses": "Statut actuel des comptes consommateurs",
      "heading.statuses-hint": "Répartition des statuts de connexion des comptes scrapés (basé sur la date de connexion du compte bancaire)",
      "heading.breakdown": "Vues approfondies",
      "heading.activated-consumers-unique": "Activés coupons uniques",
      "heading.activated-consumers-unique-hint": "Consommateurs ayant au moins un coupon unique réclamé (basé sur la date de consommation du coupon)",
      "heading.total-unique": "Total coupons uniques",
      "heading.total-unique-hint": "Nombre de coupons uniques réclamés (basé sur la date de consommation du coupon)",
      "heading.activated-consumers-generic": "Activés coupons génériques",
      "heading.activated-consumers-generic-hint": "Consommateurs ayant affiché au moins un coupon générique (basé sur la date de création du coupon)",
      "heading.total-generic": "Total coupons génériques",
      "heading.total-generic-hint": "Nombre de coupons génériques affichés (basé sur la date de création du coupon)",

      "tab": {
        "consumers": "Consommateurs",
        "funnel": "Funnel",
        "audience": "Audience",
        "rewards": "Récompenses automatiques",
        "lbs": "LBS",
        "gifts": "Dons",
        "coupons": "Coupons",
        "vouchers": "Vouchers"
      },

      "funnel": {
        "accounts-created": "Création du compte",
        "accounts-created-hint": "Nouveaux consommateurs (basé sur la date de création du compte)",
        "accounts-connected": "Connexion aux comptes bancaires",
        "accounts-connected-hint": "Consommateurs ayant connecté au moins un compte bancaire (basé sur la date de création du compte)",
        "transactions-shared": "Partage des transactions",
        "transactions-shared-hint": "Consommateur ayant effectué au moins une transaction éligible aux rewards (basé sur la date de création du compte)",
        "transactions-shared-long": "Partage des transactions récentes",
        "transactions-shared-long-hint": "Consommateur ayant effectué au moins une transaction éligible aux rewards durant les 30 derniers jours (basé sur la date de création du compte)",
      },

      "rewards": {
        "total-rewards": "Nombre total de rewards",
        "total-rewards-hint": "Nombre de rewards générés (basé sur la date d'exécution de la transaction)",
        "total-amount-rewards": "Montant total des rewards",
        "total-amount-rewards-hint": "Montant total des rewards générés (basé sur la date d'exécution de la transaction)",
        "sale-generated": "Chiffre d'affaires généré",
        "sale-generated-hint": "Montant total des transactions rewardées (basé sur la date d'exécution de la transaction)",
        "total-fees": "Commissions",
        "total-fees-hint": "Montant total des commissions (basé sur la date d'exécution de la transaction)",
        "total-vouchers": "Total vouchers",
        "total-voucher-value": "Valeur totale des vouchers",
        "total-voucher-sell": "Ventes totales de vouchers",
        "total-voucher-discount": "Réduction totale des vouchers",
        "total-voucher-commission": "Commission totale des vouchers",
        "rewards-per-merchant": "Nombre de récompenses par marchand",
        "reward-amount-per-brand": "Montant des récompenses par enseigne",
        "commission-per-brand": "Commission par enseigne",
        "activated-consumers": "Activés",
        "activated-consumers-hint": "Consommateurs ayant au moins un reward généré (basé sur la date d'exécution de la transaction)",
        "participation-rate": "Taux de participation",
        "participation-rate-hint": "Nombre moyen des rewards générés par consommateur activé (basé sur la date d'exécution de la transaction)",
        "average-earnings": "Gains moyens",
        "average-earnings-hint": "Montant moyen des rewards générés par consommateur (basé sur la date d'exécution de la transaction)",
        "average-basket": "Panier Moyen",
        "average-basket-hint": "Montant moyen des transactions rewardées (basé sur la date d'exécution de la transaction)",
        "brand-distribution": "Répartition des rewards par marchand",
        "brand-distribution-hint": "Nombre de rewards et montant total des rewards par marchand (basé sur la date d'exécution de la transaction)",
        "brand-total": "Total des rewards par marchand",
        "brand-total-amount": "Montant total des rewards par marchand",
        "brand-earnings": "Gains moyens par marchand",
        "brand-earnings-hint": "Montant moyen des transactions rewardées (basé sur la date d'exécution de la transaction)",
        "merchants": "Marchands",
        "merchants-hint": "Répartition des rewards par marchand",
      },

      "lbs": {
        "activated-consumers": "Activés",
        "activated-consumers-hint": "Consommateurs ayant au moins un reward LBS généré (basé sur la date d'exécution de la transaction)",
        "total-rewards": "Nombre total de rewards LBS",
        "total-rewards-hint": "Nombre de rewards LBS générés (basé sur la date d'exécution de la transaction)",
        "total-amount-rewards": "Montant total des rewards LBS",
        "total-amount-rewards-hint": "Montant total des rewards LBS générés (basé sur la date d'exécution de la transaction)",
        "total-fees": "Commissions LBS",
        "total-fees-hint": "Montant total des commissions LBS (basé sur la date d'exécution de la transaction)",
        "merchants": "Marchands LBS",
        "merchants-hint": "Répartition des rewards LBS par marchand",
        "brand-earnings": "Gains moyens par marchand LBS",
        "brand-earnings-hint": "Montant moyen des rewards LBS générés par marchand (basé sur la date d'exécution de la transaction)",
      },

      "gifts": {
        "activated-consumers": "Activés",
        "activated-consumers-hint": "Consommateurs ayant au moins un don généré (basé sur la date de création du don)",
        "total-gifts": "Nombre total de dons",
        "total-gifts-hint": "Nombre de dons générés (basé sur la date de création du don)",
        "total-amount": "Montant total des dons",
        "total-amount-hint": "Montant total des dons générés (basé sur la date de création du don)",
      },

      "coupons": {
        "activated-consumers-unique": "Activés coupons uniques",
        "activated-consumers-unique-hint": "Consommateurs ayant au moins un coupon unique réclamé (basé sur la date de consommation du coupon)",
        "total-unique": "Total coupons uniques",
        "total-unique-hint": "Nombre de coupons uniques réclamés (basé sur la date de consommation du coupon)",
        "activated-consumers-generic": "Activés coupons génériques",
        "activated-consumers-generic-hint": "Consommateurs ayant affiché au moins un coupon générique (basé sur la date de création du coupon)",
        "total-generic": "Total coupons génériques",
        "total-generic-hint": "Nombre de coupons génériques affichés (basé sur la date de création du coupon)",
      },

      "statuses": {
        "UNKNOWN": "Le statut est inconnu, la plupart du temps parce que le consommateur n’a pas encore synchronisé son compte.",
        "DISABLED": "La synchronisation a été désactivée pour cette connexion.",
        "ERROR": "Erreur de synchronisation (mauvaises informations d’identification et/ou le consommateur doit effectuer une action sur le site de sa banque).",
        "CHALLENGE_REQUIRED": "Le consommateur doit saisir un code spécial envoyé par sa banque pour valider la synchronisation.",
        "SCRAPPING": "Le compte bancaire du consommateur est en cours de synchronisation.",
        "SUCCESS": "La synchronisation du compte bancaire du consommateur a été un succès.",
        "SCA_REQUIRED": "Un processus SCA complet doit être effectué en mettant à jour la connexion.",
        "WEBAUTH_REQUIRED": "Un processus d’authentification complet est nécessaire pour mettre à jour la connexion via une redirection.",
        "WRONG_PASS": "Le consommateur doit saisir ses informations d’identification parce qu’elles sont invalides ou obsolètes.",
        "ACTION_NEEDED": "Le consommateur doit effectuer une action spéciale sur le site web de sa banque, plus de détails sont disponibles dans le ”error_message”",
        "alert": "Moins de {percent}% des statuts actuels des comptes d'utilisateurs sont en succès, vous pourriez vouloir améliorer ce score."
      },

      "shared": {
        "actual": "Réel",
        "cumulative": "Cumulé",
        "earnings": "Gains",
        "updated-at": "Données actualisées le ",
        "view-all": "Voir tout",
      }
    }
  },

  // Brands

  "brands": {
    "list": {
      "heading": "Enseignes",
      // "heading.store": "Magasin",
      "button.create": "Ajouter une enseigne",
      "empty": "Vous n’avez pas encore de enseigne.",
      "api.not-found": "Nous ne trouvons pas cette entreprise"
    },
    "form": {
      "heading": "Enseigne",
      "heading.brand": "Enseigne",
      "heading.picture": "Logo",
      "heading.terms": "Conditions légales",
      "form.success": "La enseigne a été mise à jour.",
      "heading.essential": "L’essentiel",
      "heading.stores": "Magasins",
      "stores-empty": "Cette enseigne ne comporte pas encore de magasin…",
      "stores-added": "{ nb, plural, =1 {# magasin sera lié} other {# magasins seront liés} } à cette enseigne après sauvegarde…",
      "dialog.must-be-saved": "Sauvegarder les modifications avant de sélectionner des magasins ?"
    },
    "recipients": {
      "heading": "Enseignes / Magasins",
      "heading.choose": "Choisissez les magasins",
      "search-store": "Rechercher un magasin…",
      "empty": "Aucun magasin trouvé",
      "empty-cart": "Aucun élément sélectionné",
      "select-hint": "Sur cette page",
      "store-count": "{ nb, plural, =0 {Aucun magasin} =1 {# magasin} other {# magasins} }",
    },
  },

  // Technicals

  "technicals": {
    "integration": {
      "heading": "Intégration",
      "form.success": "Paramètres édités avec succès.",
      "awin": {
        "heading": "Awin",
        "created": "En cours de synchronisation avec Awin.",
        "failed": "Une erreur est survenue. Veuillez vérifier votre clé API Awin.",
        "noempty": "La clé API Awin ne doit pas être vide",
      }
    },
    "docs": {
      "heading": "Développeur / Documentations API",
      "heading.doc": "Documentation API :",
      "group": 'Documentations {role}',
      "type": {
        "connector": "Connecteur",
        "injector": "Injecteur",
        "program_manager": "Program Manager",
        "m2m": "Program M2M"
      }
    },
    "logs": {
      "heading": "Développeur / Journal des évènements",
      "empty": "Il n’y a pas encore de données disponibles…",
      "button.edit": "Gérer les Webhooks"
    },
    "webhooks": {
      "heading": "Développeurs / Webhooks",
      "heading.first": "Qu’est-ce qu’un webhook ?",
      "heading.second": "Pour configurer vos webhooks :",
      "heading.basic": "Authentification Basic Auth",
      "heading.hmac": "Authentification HMAC",
      "heading.header": "Authentification par Header",
      "heading.hooks": "Hooks",
      "text.first": "Les webhooks vous permettent de recevoir des données de manière asynchrone. Ces données sont transmises au format JSON vers les URLs que vous aurez configurées dans cette interface.",
      "text.second-1": "Choisissez un type de webhook dans la colonne de gauche. Pour plus de détails sur les différents types de webhooks, consultez notre documentation.",
      "text.second-2": "Renseignez l'URL qui recevra et traitera le webhook dans votre application.",
      "message.success.heading": "Tout semble prêt !",
      "message.success.text": "Ajoutez le webhook de votre choix pour l’installer.",
      "secret-hint": "32 caractères minimum, alphanumérique.",
      "form.success": "Vos paramètres ont été mis à jour.",
      "send.success": "Une requête de test envoyée vers la callback URL.",
      "remove.success": "Ce Webhook sera définitivement supprimé après 'Sauvegarder'.",
      "test.success": "Envoyé",
      "button": {
        "settings": "Réglages"
      },
      "group": {
        "cashback": "Cashbacks",
        "payment": "Paiements",
        "consumer": "Consommateurs",
        "affiliation": "Affiliations",
        "offer": "Offres",
      },
      "event": {
        "AFFILIATION_CANCELLED": "Un webhook est envoyé à l’URL lorsqu’un reward d'affiliation en attente de validation est annulé.",
        "AFFILIATION_CREATED": "Un webhook est envoyé à l’URL lorsqu'un consommateur vient de recevoir un nouveau remboursement d'affiliation.",
        "AFFILIATION_PAID_IN": "Un webhook est envoyé à l’URL lorsque le remboursement d'affiliation est validé par le marchand (automatiquement après le délai de validation).",
        "AFFILIATION_PAID_OUT": "Un webhook est envoyé à l’URL lorsque le marchand a payé le remboursement d'affiliation.",
        "AFFILIATION_POOLED": "Un webhook est envoyé à l’URL lorsque le montant d’un reward d'affiliation est déposé sur la cagnotte d’un utilisateur.",
        "AFFILIATION_VALIDATED": "Un webhook est envoyé à l’URL lorsque la cagnotte a été déclenchée et le remboursement d'affiliation versé sur le compte de paiement.",
        "CONSUMER_REWARD_CANCELLED": "Un webhook est envoyé à l’URL lorsque vous pourrez annoncer à un consumer qu’un reward en attente de validation est annulé.",
        "CONSUMER_REWARD_PAID": "Un webhook est envoyé à l’URL lorsque vous pourrez annoncer à un consommateur que son reward a été versé.",
        "CONSUMER_REWARD_POOLED": "Un webhook est envoyé à l’URL lorsque le montant d’un reward est déposé sur la cagnotte d’un utilisateur.",
        "CONSUMER_REWARD_VALIDATION": "Un webhook est envoyé à l’URL lorsque vous pourrez annoncer au consommateur qu’un reward est en attente.",
        "NEW_OFFER_AVAILABLE": "Un webhook est envoyé à l’URL lorsqu’une nouvelle offre est créée.",
        "OFFER_CASHBACK_RATE_INCREASE": "Un webhook est envoyé à l’URL lorsque le taux de cashback d’une offre est modifié à la hausse.",
        "OFFER_ENDING_SOON_BUDGET": "Un webhook est envoyé à l’URL lorsqu’une offre se termine bientôt (80% du budget).",
        "OFFER_ENDING_SOON_DATE": "Un webhook est envoyé à l’URL lorsqu’une offre se termine bientôt (48h avant la date de fin).",
        "OFFER_RATE_INCREASE": "Un webhook est envoyé à l’URL lorsque le taux de cashback d’une offre est modifié à la hausse.",
        "PAYOUT_ERROR": "Un webhook est envoyé à l’URL lorsque nous rencontrons une erreur de transfert et que le remboursement ne peut pas être versé sur le compte de paiement.",
        "PAYOUT_SUCCESS": "Un webhook est envoyé à l’URL lorsque le transfert des remboursements est accepté par notre prestataire de service de paiement.",
        "REWARD_CANCELLED": "Un webhook est envoyé à l’URL lorsqu’un reward en attente de validation est annulé.",
        "REWARD_CREATED": "Un webhook est envoyé à l’URL lorsqu’un consommateur vient de recevoir un nouveau remboursement.",
        "REWARD_PAID_IN": "Un webhook est envoyé à l’URL lorsque le montant du reward a quitté le wallet marchand pour arriver sur le wallet PM.",
        "REWARD_PAID_OUT": "Un webhook est envoyé à l’URL lorsque la cagnotte a été déclenchée et le remboursement versé sur le compte de paiement.",
        "REWARD_VALIDATED": "Un webhook est envoyé à l’URL lorsque le remboursement est validé par le marchand (automatiquement après le délai de validation).",
        "SCRAPPING_ERROR": " Un webhook est envoyé à l’URL lorsqu’un consommateur rencontre une erreur de scrapping.",
        "VENTILATION_FILE_AVAILABLE": "Un webhook est envoyé à l’URL lorsqu’un nouveau fichier de ventilation est disponible.",
      }
    },

    "tokens": {
      "heading": "Développeurs / Clés API",
      "empty": "Aucune Clé API disponible…",
      "role": {
        "PROGRAM_M2M": "Program M2M",
        "CONNECTOR": "Connecteur",
        "INJECTOR": "Injecteur"
      },
      "dialog": {
        "success": {
          "title": "Clé API générée avec succès",
          "warning-title": "Important :",
          "warning-text-token": "Ceci est la seule fois où vous pourrez voir ce jeton.",
          "warning-text-copy": "Veuillez le copier maintenant et le stocker dans un endroit sécurisé.",
          "api-key": "Clé API",
          "client-secret": "Client Secret",
          "jwt": "JWT",
          "jwt-error": "Échec de l'émission d'un JWT. Vérifiez que le client ID et le secret sont corrects."
        }
      },
      "button": {
        "copy": "Copier le jeton",
        "generate": "Générer une Clé API",
        "doc": "Documentation API",
        "get-jwt": "Obtenir un JWT",
        "copy-jwt": "Copier le JWT",
      },
      "form": {
        "ttl-hint": "Laisser vide pour utiliser la valeur par défaut du serveur (3600 s).",
      }
    },
    "shared": {
      "label": {
        "REWARD_CREATED": "Reward Créé",
        "REWARD_VALIDATED": "Reward Validé",
        "REWARD_PAID_IN": "Reward Paid In",
        "REWARD_PAID_OUT": "Reward Paid Out",
        "CONSUMER_REWARD_POOLED": "Consumer Reward Pooled",
        "CONSUMER_REWARD_PAID": "Consumer Reward Paid",
        "CONSUMER_REWARD_CANCELLED": "Consumer Reward Cancelled",
        "CONSUMER_REWARD_VALIDATION": "Consumer Reward Validation",
        "SCRAPPING_ERROR": "Erreur de Scrapping",
        "PAYOUT_SUCCESS": "Pay Out avec succès",
        "PAYOUT_ERROR": "Erreur de Pay Out",
        "AFFILIATION_CREATED": "Affiliation Créé",
        "AFFILIATION_VALIDATED": "Affiliation Validé",
        "AFFILIATION_PAID_IN": "Affiliation paid in",
        "AFFILIATION_PAID_OUT": "Affiliation paid out",
        "AFFILIATION_POOLED": "Affiliation pooled",
        "AFFILIATION_CANCELLED": "Affiliation cancelled",
        "VENTILATION_FILE_AVAILABLE": "Ventilation file available",
        "NEW_OFFER_AVAILABLE": "New offer available",
        "OFFER_ENDING_SOON_DATE": "Offer soon ending date",
        "OFFER_ENDING_SOON_BUDGET": "Offer soon ending budget",
        "OFFER_CASHBACK_RATE_INCREASE": "Offer cashback rate increase",
        "filter_type": "Filtrer par type...",
      },
      "hint": {
        "REWARD_CREATED": "Appelée lorsqu’un consommateur vient de recevoir un nouveau remboursement",
        "REWARD_VALIDATED": "Appelée lorsque le remboursement est validé par le marchand (automatiquement après le délai de validation)",
        "REWARD_PAID_IN": "Appelée lorsque le marchand a payé le remboursement",
        "REWARD_PAID_OUT": "Appelée lorsque la cagnotte a été déclenchée et le remboursement versé sur le compte de paiement",
        "CONSUMER_REWARD_POOLED": "Un webhook est envoyé à l’URL lorsque le montant d’un reward est déposé sur la cagnotte d’un utilisateur.",
        "CONSUMER_REWARD_PAID": "Un webhook est envoyé à l’URL lorsque vous pourrez annoncer à un consommateur que son reward a été versé.",
        "CONSUMER_REWARD_CANCELLED": "Un webhook est envoyé à l’URL lorsque vous pourrez annoncer à un consumer qu’un reward en attente de validation est annulé.",
        "CONSUMER_REWARD_VALIDATION": "Un webhook est envoyé à l’URL lorsque vous pourrez annoncer au consommateur qu’un reward est en attente.",
        "SCRAPPING_ERROR": "Appelée lorsqu’un consommateur rencontre une erreur de scrapping",
        "PAYOUT_ERROR": "Appelée lorsque nous rencontrons une erreur de transfert et que le remboursement ne peut pas être versé sur le compte de paiement",
        "PAYOUT_SUCCESS": "Appelée lorsque le transfert pour le paiement des remboursements est accepté par notre prestataire de service de paiement",
        "AFFILIATION_CREATED": "Appelée lorsqu'un consommateur vient de recevoir un nouveau remboursement d'affiliation",
        "AFFILIATION_VALIDATED": "Appelée lorsque le remboursement d'affiliation est validé par le marchand (automatiquement après le délai de validation)",
        "AFFILIATION_PAID_IN": "Appelée lorsque le marchand a payé le remboursement d'affiliation",
        "AFFILIATION_PAID_OUT": "Appelée lorsque la cagnotte a été déclenchée et le remboursement d'affiliation versé sur le compte de paiement",
        "AFFILIATION_POOLED": "Un webhook est envoyé à l’URL lorsque le montant d’un reward d'affiliation est déposé sur la cagnotte d’un utilisateur.",
        "AFFILIATION_CANCELLED": "Un webhook est envoyé à l’URL lorsqu’un reward d'affiliation en attente de validation est annulé.",
        "VENTILATION_FILE_AVAILABLE": "Un webhook est envoyé à l’URL lorsqu’un nouveau fichier de ventilation est disponible.",
        "NEW_OFFER_AVAILABLE": "Un webhook est envoyé à l’URL lorsqu’une nouvelle offre est créée.",
        "OFFER_ENDING_SOON_DATE": "Un webhook est envoyé à l’URL lorsqu’une offre se termine bientôt.",
        "OFFER_ENDING_SOON_BUDGET": "Un webhook est envoyé à l’URL lorsqu’une offre se termine bientôt.",
        "OFFER_CASHBACK_RATE_INCREASE": "Un webhook est envoyé à l’URL lorsque le taux de cashback d’une offre est modifié à la hausse.",
      },
      "status": {
        "1xx": "1xx - Information",
        "2xx": "2xx - Succès",
        "3xx": "3xx - Redirection",
        "4xx": "4xx - Erreur client",
        "5xx": "5xx - Erreur serveur",
        "others": "Autres",
        "filter": "Filtrer par status..."
      },
    },
  },

  // 404

  "errors": {
    "404": {
      "heading": "La page demandée n’a pas été trouvée…",
      "message": "Cliquez le bouton ci-dessous pour retourner à la page précédente.",
      "button.back": "Retour à la page précédente",
    },
  },

  // Shared

  "shared": {
    "apply-all": "Appliquer à tous",
    "empty": "Aucune données pour l‘instant…",
    "clipboarded": "Copié dans le presse-papier",
    "timezone": "Selon le fuseau horaire d’Europe centrale.",
    "type-search": "Taper pour rechercher…",
    "not-found": "Aucun élément trouvé…",
    "loading": "Chargement…",
    "warning": "Attention :",
    "need-help-call": "Besoin d’aide ? Appelez-nous !",
    "yes": "Oui",
    "no": "Non",
    "tags": {
      "start_date": "Date de début",
      "end_date": "Date de fin",
      "rate": "Taux",
    },
    "api": {
      "error": {
        "down": "Nous rencontrons quelques problèmes avec nos serveurs. Veuillez réessayer ultérieurement."
      }
    },
    "heading": {
      "brand-details": "Détails de l’enseigne",
      "program-details": "Détails du programme",
      "commission-group": "Commission groups"
    },
    "form": {
      "invalid": "Le formulaire est invalide. Veuillez corriger les champs marqués.",
      "error": {
        "required": "Obligatoire",
        "email": "Cette adresse email est invalide",
        "password-match": "Le mot de passe et sa confirmation ne correspondent pas",
        "password-strength": "Doit contenir au moins 1 chiffre",
        "password-not-found": "Mot de passe incorrect",
        "minlength": "Doit contenir au moins { requiredLength } caractères",
        "pattern": "Valeur invalide",
        "max": "Doit être inférieur à { requiredValue }",
        "min": "Doit être supérieur à { requiredValue }",
        "type": "Type de fichier est invalide. { requiredValue }",
        "min_size": "Fichier trop léger. Min { readableValue }",
        "max_size": "Fichier trop lourd. Max { readableValue }",
        "min_width_height": "Trop petite. Min { requiredValue } pixels",
        "max_width_height": "Trop grande. Max { requiredValue } pixels",
        "min_width": "Trop petite (largeur). Min { requiredValue } pixels",
        "max_width": "Trop grande (largeur). Max { requiredValue } pixels",
        "min_height": "Trop petite (hauteur). Min { requiredValue } pixels",
        "max_height": "Trop grande (hauteur). Max { requiredValue } pixels",
        "min_aspect_ratio": "Format trop vertical. Min { requiredValue } %",
        "max_aspect_ratio": "Format trop horizontal. Max { requiredValue } %",
        "iban": "IBAN invalide",
        "bic": "BIC invalide",
        "already-exists": "Existe déjà dans notre base de données"
      },
      "success": {
        "upload": "Fichier uploadé avec succès"
      }
    },
    "dialog": {
      "siret": {
        "heading": "Rechercher un magasin par son Siret"
      },
      "mandate": {
        "heading": "Demande de mandat",
        "text": `
          Dans le cadre des nouvelles dispositions légales relatives à l’application des normes bancaires européennes, les paiements du reward et des commissions donnent lieu à un prélèvement SEPA, effectué sous une référence unique de mandat.
          Notre partenaire Mangopay est responsable de la conservation du mandat électronique.
          Par ce mandat, vous autorisez Mangopay à émettre un ordre mensuel, lorsque nécéssaire pour le prélèvement du reward et des commissions sur votre compte bancaire.
          Pour toute question, vous pouvez joindre notre support [ support@paylead.fr ]
        `
      },
      "alert": {
        "heading": "Alerte",
        "api": {
          "heading": "Ooops ! Un problème de serveur !",
          "heading.400": "Données invalides",
          "text": "Notre serveur retourne une erreur :",
          "retry": "Merci de réessayer ultérieurement.",
        }
      },
      "confirm": {
        "heading": "Confirmation",
        "text": "Confirmez-vous ?",
        "text.navigation": "Vous quittez cette page sans sauvegarder vos modifications.",
        "text.delete.item": "Merci de confirmer la suppression de cet élément.",
        "text.delete.picture": "Merci de confirmer la suppression de cette image.",
        "text.delete.store": "Merci de confirmer la suppression de ce point de vente.",
        "text.deactivate-user": "Êtes-vous sûr de vouloir désactiver cet utilisateur ? Cette action est irréversible.",
      },
      "token-generate": {
        "heading": "Génération d'une Clé API",
      },
      "password": {
        "heading": "Dévérouillage de sécurité",
        "error": "Mot de passe incorrect.",
      },
      "illustration": { "heading": "Veuillez choisir une illustration", "notfound": "Aucune illustration disponible" }
    },
    "sidebar": {
      "documentation": "Doc",
      "back": "Retour",
      "support": "Support",
      "ticket": "Ticket",
      "reporting": "Reporting",
      "docs": "Documentations API",
      "segments": "Segments",
      "campaigns": "Campagnes",
      "gifts": "Dons",
      "ventilation": "Ventilation",
      "ventilation_affiliation": "Ventilation d'affiliation",
      "coupons": "Coupons",
      "kyb": "Vérifications légales",
      "help": "Besoin d’aide ?",
      "consumers": "Consommateurs",
      "consumer-events": "Evènements de vie",
      "performances": "Performances",
      "program": "Programme",
      "affiliations": "Affiliations",
      "management": "Gestion des magasins",
      "brands": "Enseignes",
      "networks": "Réseaux",
      "dashboard": "Tableau de bord",
      "offers": "Offres",
      "logs": "Journal des évènements",
      "hooks": "Hooks",
      "tokens": "Clés API",
      "integration": "Intégration",
      "users": "Utilisateurs",
      "transactions": "Transactions",
      "invoices": "Factures",
      "account": "Mon compte",
      "merchant": "Enseigne",
      "stores": "Magasins",
      "rewards": "Rewards",
      "vouchers": "Vouchers",
      "payment": "Moyens de paiement",
      "settings": "Paramètres",
      "status": "Statuts du compte",
      "logout": "Déconnexion",
      "logged-as": "En tant que",
      "technical": "Développeurs",
      "intro-1-title": "PayLead, la révolution du marketing client",
      "intro-1-text": "Découvrez une solution innovante pour atteindre vos consommateurs et prospects. Quelques clics vous suffisent pour lancer une campagne de promotion performante qui s’adapte à votre stratégie : online et/ou offline, localisée ou nationale, ciblée ou étendue.",
      "intro-2-title": "Votre campagne, gratuitement",
      "intro-2-text": "Offrez vous une visibilité optimale auprès de vos consommateurs et prospects : vous ne payez que lorsqu’une vente est réalisée, sous forme d’un reward reversé au client.",
      "intro-3-title": "Pilotez la performance",
      "intro-3-text": "Bénéficiez d’indicateurs de performance précis qui vous permettront d’évaluer et d’ajuster vos campagnes, tout en visualisant votre retour sur investissement.",
      "intro-4-title": "Améliorez votre connaissance client",
      "intro-4-text": "Appuyez-vous sur notre expertise en Big Data et Intelligence Artificielle pour mieux comprendre les habitudes de consommation de vos clients afin d’optimiser vos stratégies marketing.",
    },
    "pagination": {
      "meta": "{ from } / { to } sur {total, plural, =1 {# élément} other {# éléments} }",
      "empty": "Aucun élément…",
    },
    "filter": {
      "keyword": "Filtrer par mot-clé…",
      "date-from": "Date de début…",
      "date-to": "Date de fin…",
      "date": "Date…",
      "segments": "Filter par segments",
      "exact-consumer-id": "Rechercher avec l'ID du consommateur"
    },
    "counts": {
      "frequency": "1 sur {frequency} transactions",
      "offers": "{ nb, plural, =0 {Aucune offre} =1 {# offre} other {# offres} }",
    },
    "role": {
      "ADMIN": "Administration",
      "TECHNICAL": "Technique",
      "FINANCE": "Finance",
      "OFFER": "Offres",
      "GIFT": "Dons",
      "SUPPORT": "Support client",
      "REPORTING": "Reporting"
    },
    "charts": {
      "subscribers-evolution": "Évolution des souscriptions",
      "churners-evolution": "Évolution des désinscriptions",
      "rewarded-consumers": "Consommateurs récompensés",
      "reward-amount-commission": "Montant des récompenses + commission",
      "number-of-rewards": "Nombre de récompenses",
      "voucher-discount": "Somme des réductions de vouchers",
      "voucher-by-consumers": "Vouchers par consommateur",
      "vouchers": "Vouchers",
      "labels": {
        "subscriptions": "Inscriptions",
        "cumulative-subscriptions": "Inscriptions cumulées",
        "churners": "Désinscriptions",
        "cumulative-churners": "Désinscriptions cumulées",
        "rewarded": "Récompensés",
        "program-fees": "Commissions",
        "reward-amount": "Montant récompenses",
        "discount": "Réduction",
        "fees": "Frais",
        "count": "Nombre",
      },
    },
    "metrics": {
      "total-subscribers": "Total souscriptions",
      "total-subscribers-hint": "Nombre total d'inscriptions au programme depuis le lancement",
      "total-churners": "Total désinscriptions",
      "total-churners-hint": "Nombre total d'utilisateurs qui se sont désabonnés du programme depuis le lancement",
      "total-onboarded": "Total inscrits",
      "total-onboarded-hint": "Nombre total d'utilisateurs enregistrés dans le programme à ce jour",
      "total-rewarded": "Total récompensés",
      "total-rewarded-hint": "Nombre total d'utilisateurs ayant généré du cashback depuis le lancement du programme",
      "total-playground": "Total playground",
      "total-playground-hint": "Montant total des revenus (cashbacks + commissions) générés depuis le lancement du programme",
      "total-commission": "Total commission",
      "total-commission-hint": "Montant total des commissions générées depuis le lancement",
      "number-of-rewards": "Nombre de récompenses",
      "number-of-rewards-hint": "Nombre total de cashbacks générés depuis le lancement",
      "reward-amount": "Montant des récompenses",
      "reward-amount-hint": "Montant total des cashbacks générés depuis le lancement",
      "total-discounts": "Total réductions",
      "total-discounts-hint": "Montant total des réductions de vouchers générées depuis le lancement",
      "total-fees": "Total frais",
      "total-fees-hint": "Montant total des frais générés depuis le lancement",
      "total-vouchers": "Total vouchers",
      "total-voucher-value": "Valeur totale des vouchers",
      "total-voucher-sell": "Ventes totales de vouchers",
      "total-voucher-discount": "Réduction totale des vouchers",
      "total-voucher-commission": "Commission totale des vouchers",
      "rewards-per-merchant": "Nombre de récompenses par marchand",
      "reward-amount-per-brand": "Montant des récompenses par enseigne",
      "commission-per-brand": "Commission par enseigne",
    },
    "status": {
      "WEBAUTH_REQUIRED": "Webauth demandé",
      "WRONG_PASS": "Mauvais pass.",
      "ACTION_NEEDED": "Action requise",
      "ALL": "Tous",
      "CREATED": "Créé",
      "ACTIVE": "Actif",
      "CANCELLED": "Annulé",
      "CHALLENGE_REQUIRED": "Action requise",
      "COMPLETED": "Épuisé",
      "DEACTIVATED": "Annulé",
      "DISABLED": "Désactivé",
      "DRAFT": "Brouillon",
      "ENDED": "Terminé",
      "ERROR": "En erreur",
      "FAILED": "Echoué",
      "HIGH": "High",
      "HIGHEST": "Highest",
      "INACTIVE": "Inactif",
      "MISSING": "Manquant",
      "NORMAL": "Normal",
      "NOT_ATTRIBUTED": "Non attribué",
      "NOT_STARTED": "À venir",
      "PAID_IN": "Cagnotte",
      "PAID_OUT": "Payé",
      "PAID": "Payé",
      "PAYMENT_FAILED": "Echec de paiement",
      "PENDING_MODERATION": "En attente de modération",
      "PENDING_VALIDATION": "En attente de validation",
      "PENDING_ATTRIBUTION": "En attente d'attribution",
      "PENDING": "En attente",
      "POOLED": "En cagnotte",
      "PUBLISHED": "Publié",
      "REJECTED": "Rejeté",
      "SCA_REQUIRED": "Authentification nécessaire",
      "SCRAPPING": "En cours",
      "SUCCESS": "Ok",
      "SUCCEEDED": "Ok",
      "SYNCED": "Synchronisé",
      "TRANSFERED": "Transferé",
      "UNKNOWN": "Inconnu",
      "VALIDATED": "Validé",
      "VALIDATION": "En validation",
      "WAITING_FOR_PUBLICATION": "En attente",
      "RESERVED": "Réservé",
      "CONFIRMED": "Confirmé",
      "READY": "Prêt",
      "REFUNDING": "Remboursement",
      "REFUNDED": "Remboursé",
      "REFUND_REJECTED": "Remboursement rejeté",
      "TODO": "À faire",
    },
    "table": {
      "parameters": "Paramètres",
      "roles": "Rôles",
      "discount": "Discount",
      "rentability": "Rentabilité",
      "price": "Prix",
      "value": "Valeur",
      "activations": "Activations",
      "campaign": "Campagne",
      "channel": "Canal",
      "chanel": "Canal",
      "group": "Groupe",
      "remaining": "Restant",
      "offer-activated": "Offres activées",
      "universes": "Univers",
      "segments": "Segments",
      "gifts": "Dons",
      "token": "Clé API",
      "label": "Libellé",
      "description": "Description",
      "scopes": "Portées",
      "ttl": "TTL (s)",
      "client-id": "Client ID",
      "payout": "Pay out",
      "reward": "Reward",
      "last-month": "Mois dernier",
      "bankwire": "Transfert bancaire",
      "origin": "Origine",
      "payout-id": "Payout ID",
      "tos-acceptance": "CGU acceptées",
      "consumer": "Consommateur",
      "url": "URL",
      "url-callback": "Callback URL",
      "accounts": "Comptes",
      "transfer": "Transfers",
      "transaction": "Transaction",
      "id": "ID",
      "last-activity-date": "Dernière activité",
      "scrapping": "Scrapping",
      "descriptor": "Libellé",
      "highlight": "Highlight",
      "stores": "Magasins",
      "offers-issued": "Offres publiées",
      "offers-live": "Offres en cours",
      "brand": "Enseigne",
      "invididual": "Individu",
      "network": "Réseau",
      "first-name": "Prénom",
      "last-name": "Nom",
      "completion": "Complétion",
      "created-at": "Création",
      "triggered-at": "Déclenchement",
      "updated-at": "Modification",
      "activity": "Dernière activité",
      "email": "Email",
      "actions": "Actions",
      "amount": "Montant",
      "card": "Carte",
      "cashback": "Reward",
      "city": "Ville",
      "commission": "Commission",
      "date": "Date",
      "date-accepted": "Acceptation",
      "date-publication": "Publication",
      "date-most-recent-transaction": "Récente transaction",
      "date-first": "1ère connexion",
      "date-sync": "Connexion",
      "date-sync-success": "Connexion réussie",
      "dates": "Période",
      "dates-activation": "Période d'activation",
      "real-end-date": "Date réelle de fin",
      "fees": "Commission",
      "values": "Valeurs",
      "invoice": "Facture",
      "merchant": "Enseigne",
      "month": "Mois",
      "name": "Nom",
      "name-original": "Nom orignal",
      "name-edited": "Nom édité",
      "next-try": "Prochain Essai",
      "maximum-retries": "Limite d'essais atteinte",
      "type": "Type",
      "reference": "Référence",
      "redemption": "Rédemption",
      "number": "Nombre",
      "offer": "Offre",
      "participants": "Participants",
      "rate": "Taux",
      "serial": "Numéro",
      "siret": "Siret",
      "status": "Statut",
      "zipcode": "Code postal",
      "tos-date": "Inscription",
    },
    "label": {
      "offer-lifespan": "Cycle de vie de l’offre",
      "reward-info": "Paramètre de reward",
      "audience-reach": "Audience",
      "reward-frequency": "Fréquence de reward",
      "commission-max": "Commission max.",
      "example": "Exemple",
      "callback-url": "Callback URL",
      "on": "le",
      "others": "Autres",
      "total": "Total",
      "api-key": "API key",
      "client-id": "Client ID",
      "label": "Libellé",
      "scopes": "Portées",
      "secret": "Secret",
      "secret-jwt": "JWT secret",
      "values": "Valeurs",
      "roles": "Rôles",
      "url-destination": "URL de destination",
      "reward-rate-max": "Taux de reward maximum",
      "reward-amount-fixed": "Montant maximum de reward",
      "reward-current": "Taux de reward en cours",
      "audience": "Audience",
      "audience-estimated": "Audience estimée",
      "audience-estimated-hint": "Les critères d’éligibilité seront réappliqués à la création de l’offre, ce qui peut faire varier la taille finale.",
      "audience-will-be-computed": "Calculé au démarrage de l’offre",
      "audience-computing-in-progress": "Calcul en cours",
      "documents": "Documents",
      "details": "Détails",
      "visuals": "Visuels",
      "performance": "Performance",
      "sync": "Synchronisation",
      "account": "Compte",
      "strategies": "Stratégies",
      "campaigns": "Campagnes",
      "token": "Token",
      "share": "Share",
      "price-range": "Intervalle de prix",
      "rewarded-price-range": "Intervalle de prix rewardé",
      "max-limit-transaction-amount": "Montant maximal de transaction éligible",
      "activation": "Activation",
      "channel": "Canal",
      "validation-delay": "Délai de validation",
      "channel-url": "Canal URL",
      "targeting": "Ciblage",
      "ab-testing": "Groupe de contrôle",
      "capping": "Capping",
      "segments": "Segments",
      "brand": "Enseigne",
      "brand-name": "Nom de l'enseigne",
      "application": "Canal",
      "offline": "En magasin",
      "online": "En ligne",
      "online-offline": "En ligne & en magasin",
      "terms": "Conditions légales",
      "policy.statistics": "Statistiques",
      "policy.basic": "Basique",
      "policy.transaction_triggers": "Moments de Vie",
      "policy.targeting": "Ciblage",
      "policy.smart_ranking": "Smart ranking",
      "policy.web_analytics": "Web Analytics",
      "offer-details-viewed": "Vue detail de l'offre",
      "score-onboarding": "Score d'ancienneté",
      "score-last-touch": "Score d'animation",
      "score-rewarding": "Score de fidélisation",
      "score-global": "Score d'attribution",
      "key": "Clé",
      "occurrences": "Occurrences",
      "consumers": "Consommateurs",
      "last-activity-date": "Dernière activité",
      "labels": "Labels",
      "categories": "Catégories",
      "url": "URL",
      "url-callback": "Callback URL",
      "vat": "TTC",
      "account-owner": "Titulaire du compte",
      "account-payout": "Compte Payout",
      "account-target": "Compte cible",
      "activations": "Nombre de clients",
      "activations-hint": "Nombre de participations sur la période observée",
      "address": "Adresse",
      "address-billing": "Adresse de facturation",
      "affiliate": "Affilié",
      "amount": "Montant",
      "at": "chez",
      "average": "Moyenne",
      "average-basket": "Panier moyen",
      "average-basket-hint": "Paniers moyens des clients participants sur la période observée",
      "bank-receipt": "Justificatif bancaire",
      "bic": "BIC",
      "by": "Par",
      "for": "Pour",
      "card": "Carte",
      "card-holder": "Titulaire de la carte",
      "card-number": "Numéro de carte",
      "cashback": "Reward",
      "cashback-client": "Reward client",
      "city": "Ville",
      "commission": "Commission",
      "commissions": "Commissions",
      "country": "Pays",
      "coupon": "Coupon",
      "no-file-selected": "Aucun fichier sélectionné…",
      "no-file-uploaded": "Aucun fichier uploadé…",
      "file-uploaded": "{ filename } uploadé",
      "company_number": "Siren",
      "coupon-amount": "Nombre de coupons",
      "coupon-discount": "Réduction",
      "coupon-file": "Fichier de coupons",
      "coupon-total": "Max coupons",
      "coupon-type": "Type de coupon",
      "coupon-max-per-user": "Nombre maximum par consommateur",
      "created-at": "Création",
      "executed-at": "Exécution",
      "triggered-at": "Déclenchement",
      "updated-at": "Modification",
      "date": "Date",
      "date-from": "Date de début",
      "date-to": "Date de fin",
      "date-publication": "Date de publication",
      "dates": "Dates",
      "description": "Description",
      "email": "Email",
      "emails": "emails",
      "expiry-date": "Date d’expiration",
      "fees": "Commission",
      "filename": "Nom de fichier",
      "first-name": "Prénom",
      "highlight-level": "Niveau de highlight",
      "hours": "heures",
      "iban": "IBAN",
      "keyword": "Mot-clé",
      "keywords": "Mot-clés",
      "language": "Langue",
      "last-activity": "Dernière activité",
      "last-name": "Nom de famille",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "max-spent": "Dépense Maximum",
      "merchant-name": "Nom de l’enseigne",
      "min-spent": "Dépense minimum",
      "mobile": "Mobile",
      "multiple": "Multiple",
      "name": "Nom",
      "notifications": "notifications",
      "number": "Numéro",
      "offer": "Offre",
      "offer-name": "Nom de l’offre",
      "coupon-name": "Nom du coupon",
      "offer-reference": "Référence de l'offre",
      "coupon-reference": "Référence du coupon",
      "offers": "Offres",
      "password": "Mot de passe",
      "password-old": "Mot de passe actuel",
      "password-retype": "Retaper le Mot de passe",
      "password-security": "Niveau de sécurité",
      "phone": "Téléphone",
      "price": "Niveau de prix",
      "price-max": "Prix maximum",
      "price-max-no": "Pas de prix maximum",
      "price-min": "Prix minimum",
      "price-min-no": "Pas de prix minimum",
      "privacy-acceptance": "Politique de confidentialité",
      "program-name": "Nom du programme",
      "publication-date": "Date de publication",
      "rate": "Taux de reward",
      "discount": "Taux de discount",
      "redemption": "Nombre de rewards",
      "redemption-hint": "Nombre de rewards sur la période observée",
      "redemption-rate": "Taux de participation",
      "redemption-rate-hint": "Nombre de participations, en moyenne, par client participant",
      "reference": "Référence",
      "remaining-time": "Temps restant",
      "remaining-time-count": "{ nb, plural, =0 {jour} =1 {# jour} other {# jours} }",
      "reward-average": "Reward moyen",
      "reward-average-hint": "Gain moyen par transaction rewardée",
      "acquisition-cost": "Coût d’acquisition",
      "acquisition-cost-hint": "Le coût d’acquisition moyen de chaque client ayant participé à une offre",
      "forwarded-kyc": "KYC transmis",
      "account-sync": "Sync comptes",
      "scrapping": "Scrapping",
      "screen": "Écran",
      "security-code": "Code de sécurité (CVC)",
      "security-code-help": "3 ou 4 chiffres",
      "select-file": "Choisir un fichier",
      "select-picture": "Choisir une image",
      "select-universe": "Sélectionner un univers",
      "sendings": "envois",
      "siret": "Siret",
      "siren": "Siren",
      "status": "Statut",
      "step": "Étape",
      "status-start": "Statut de départ",
      "store-name": "Raison sociale",
      "tos-acceptance": "CGU acceptées",
      "total-activations": "Total des activations",
      "total-activations-hint": "Nombre de clients participants sur la période observée. Un client est considéré comme participant s’il a reçu au moins un Reward grâce à une offre",
      "total-cashback": "Montant total des rewards",
      "total-cashback-hint": "La somme des rewards générés sur la période",
      "total-commissions": "Total des commissions",
      "total-commissions-hint": "Total des commissions versées sur la période observée",
      "total-details-views": "Nombre d’offres cliquées",
      "total-details-views-hint": "Total des clics pour accéder au détail, sur la période observée",
      "total-listing-views": "Total des offres affichées dans un listing",
      "total-listing-views-hint": "Nombre total d’affichages dans un listing",
      "total-redemption": "Nombre de Rewards",
      "total-redemption-hint": "Nombre total de Rewards versés sur la période",
      "total-spent": "Chiffre d’affaires généré",
      "total-spent-hint": "Chiffre d’affaires total généré sur la période",
      "total-to-pay": "Total à payer",
      "transaction": "Transaction",
      "transactions": "Transactions",
      "type": "Type",
      "unique-details-views": "Adhérents engagés",
      "unique-details-views-hint": "Nombre de clients ayant cliqué sur une offre",
      "unique-listing-views": "Adhérents atteints",
      "unique-listing-views-hint": "Nombre de client ayant vu une offre dans un listing",
      "universe": "Univers",
      "universes": "Univers",
      "username": "Nom d’utilisateur",
      "visitors": "visiteurs",
      "website": "Site internet",
      "zipcode": "Code postal",
      "value": "Valeur",
      "objective": "Objectif",
    },
    "widget": {
      "remaining-chars": "Caractères restants : { number }",
    },
    "button": {
      "add": "Ajouter",
      "send-test": "Envoyer test",
      "force-sync": "Synchroniser",
      "download": "Télécharger",
      "visit-site": "Vister le site web",
      "lock-again": "Vérouiller à nouveau",
      "unlock": "Dévérouiller",
      "accept": "Accepter",
      "back": "Retour",
      "cancel": "Annuler",
      "clipboard": "Presse-papier",
      "close": "Fermer",
      "confirm": "Confirmer",
      "contact-support": "Contacter le support",
      "copy": "Copier",
      "create": "Ajouter",
      "delete": "Supprimer",
      "download-logo": "Télécharger le logo",
      "download-visual": "Télécharger le visuel",
      "edit": "Éditer",
      "export": "Exporter",
      "import": "Importer",
      "invite": "Inviter",
      "know-more": "En savoir plus",
      "load": "Charger",
      "modify": "Modifier",
      "next": "Suivant",
      "ok": "Ok",
      "open": "Ouvrir",
      "prev": "Précédent",
      "publish": "Publier",
      "refresh": "Rafraîchir",
      "reject": "Rejeter",
      "save": "Sauvegarder",
      "search": "Rechercher",
      "send": "Envoyer",
      "simulate": "Simuler",
      "start-again": "Recommencer",
      "terms-hide": "Masquer les conditions générales",
      "terms-show": "Afficher les conditions générales",
      "update": "Mettre à jour",
      "select": "Sélectionner"
    },
    "granularity": {
      "no_reset": "Pas de réinitialisation",
      "daily": "Par jour",
      "weekly": "Par semaine",
      "monthly": "Par mois",
      "quarterly": "Par trimestre",
      "biannual": "Par semestre",
      "yearly": "Par année",
    },
    "date": {
      "d": "j",
      "days": "jours",
      "hours": "heures",
      "minutes": "minutes",
      "seconds": "secondes",
      "period": {
        "this-month": "Mois en cours",
        "last-month": "Mois dernier",
        "6-months": "6 mois",
        "this-year": "Année en cours",
        "last-year": "Année dernière",
        "lifetime": "Totalité",
      },
      "ago": {
        "seconds": "il y a quelques secondes",
        "minutes": "il y a {minutes, plural, =1 {une minute} other {# minutes}}",
        "hours": "il y a {hours, plural, =1 {une heure} other {# heures}}",
        "days": "il y a {days, plural, =1 {une journée} other {# jours}}",
        "months": "il y a {months, plural, =1 {un mois} other {# mois}}",
        "years": "il y a {years, plural, =1 {une année} other {# ans}}",
      },
      "day": {
        "0": "Dimanche",
        "1": "Lundi",
        "2": "Mardi",
        "3": "Mercredi",
        "4": "Jeudi",
        "5": "Vendredi",
        "6": "Samedi",
      },
      "day-short": {
        "0": "Dim.",
        "1": "Lun.",
        "2": "Mar.",
        "3": "Mer.",
        "4": "Jeu.",
        "5": "Ven.",
        "6": "Sam.",
      },
      "month": {
        "0": "Janvier",
        "1": "Février",
        "2": "Mars",
        "3": "Avril",
        "4": "Mai",
        "5": "Juin",
        "6": "Juillet",
        "7": "Août",
        "8": "Septembre",
        "9": "Octobre",
        "10": "Novembre",
        "11": "Décembre"
      },
      "month-short": {
        "0": "Jan.",
        "1": "Fév.",
        "2": "Mar.",
        "3": "Avr.",
        "4": "Mai",
        "5": "Juin",
        "6": "Juil.",
        "7": "Août.",
        "8": "Sept.",
        "9": "Oct.",
        "10": "Nov.",
        "11": "Déc.",
      },
    },
    "operator": {
      "SUM": "Somme",
      "AVG": "Moyenne",
      "MIN": "Min",
      "MAX": "Max",
    },
    "target": {
      "types": {
        "BRAND": "Achat auprès d’enseignes",
        "PURCHASE_AMOUNT": "Montant des achats",
        "PURCHASE_COUNT": "Nombre d’achats",
        "PURCHASE_FIRST_DATE": "Date du premier achat",
        "PURCHASE_FIRST_MONTHS": "Durée depuis le premier achat",
        "PURCHASE_LAST_DATE": "Date du dernier achat",
        "PURCHASE_LAST_MONTHS": "Durée depuis le dernier achat",
        "MONTHS_SINCE_LAST_PURCHASE": "Durée depuis le dernier achat",
        "REWARD_COUNT": "Nombre de cashback obtenu(s)",
      },
      "operators": {
        "AND": "Et",
        "OR": "Ou",
        "=": "Égal(e) à",
        "!=": "Différent(e) de",
        "<": "Inférieur(e) à",
        "<=": "Inférieur(e) ou égal(e) à",
        ">": "Supérieur(e) à",
        ">=": "Supérieur(e) ou égal(e) à",
      },
      "counts": {
        "months": "{ nb, plural, =0 {Jamais} =1 {# mois} other {# mois} }",
        "last-months": "{ nb } { period, plural, =0 {Jamais} =1 {sur le dernier mois} other {dans les # derniers mois} }",
        "date-range": "{ nb } du { start_date } au { end_date }"
      },
      "prefix": {
        "campaign": "Dans la campagne"
      }
    },
    "countries": countryList,
    "password": {
      "length": "14 caractères minimum",
      "lowercase": "1 minuscule",
      "uppercase": "1 majuscule",
      "digit": "1 chiffre",
      "special": "1 caractère spécial",
      "no_username": "Ne doit pas comporter votre nom d’utilisateur (prénom ou nom).",
      "no_product": "Ne doit pas comporter PayLead, Thor, Shift ou Cube.",
    },

    "notification": {
      "new_strategy_exposed_to_program_manager": {
        "title": "Nouvelle campagne disponible",
        "hint": "Recevez un mail lorsque qu’une nouvelle campagne est disponible",
      },
      "strategy_soon_completed": {
        "title": "Campagnes se terminant bientôt",
        "hint": "Recevez un mail lorsqu'une campagne arrive à son terme (date de fin programmée)",
      },
      "strategy_end_date_extended": {
        "title": "Campagne étendue",
        "hint": "Recevez un mail lorsqu'une campagne est prolongée",
      },
      "strategy_end_date_shortened": {
        "title": "Campagne raccourcie",
        "hint": "Recevez un mail lorsqu'une campagne est raccourcie",
      },
      "strategy_new_illustrations_available": {
        "title": "Nouveaux visuels disponibles",
        "hint": "Recevez un mail lorsqu'un nouveau visuel est disponible",
      },
      "strategy_new_phase_created": {
        "title": "Phase de taux boosté disponible",
        "hint": "Recevez un mail lorsqu'une phase de taux boosté est disponible",
      }
    }
  },
};
